export default __webpack_public_path__ + "static/dclogocircle-746cb80dc64eddf1d3d9414397b43c7e.png";